import { createBrowserClient } from "@supabase/ssr";

export function createClient() {
  // Fallback values prevent crashes during Next.js static page generation
  // at build time when env vars aren't available. No actual Supabase calls
  // are made during SSR (they're all in useEffect).
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL || "https://placeholder.supabase.co",
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || "placeholder"
  );
}
